import React from 'react';
import { ProductGallery } from './ProductGallery';
import { WfProductFramePreview } from '../frames/WfProductFramePreview';
export function TheMaskSection() {
  return <section id="the-mask" aria-labelledby="the-mask-title" className="scroll-mt-16" data-id="element-275" data-mp="2ld0ot5980atv">
      <div className="mx-auto max-w-page px-5 py-20 md:px-10 lg:py-28" data-id="element-276" data-mp="2lety6sb7x95k">
        <h2 id="the-mask-title" className="sr-only" data-id="element-277" data-mp="2gkprma5v7350">
          The Mask
        </h2>
        <div className="grid gap-12 lg:grid-cols-[1.15fr_1fr] lg:gap-20" data-id="element-278" data-mp="2uce105oqbdia">
          <ProductGallery data-id="element-279" data-mp="2qcn3lj4p5z4s" />
          <div className="lg:pt-6" data-id="element-280" data-mp="2qbc0llj2sveq">
            <WfProductFramePreview data-id="element-281" data-mp="2qega8yfb8jcs" />
          </div>
        </div>
      </div>
    </section>;
}